import React, { useEffect, useState } from 'react';
import {
  Grid2, Box, Typography, TextField, Button, Card, CardContent, CardHeader,
  TableContainer, Table, TableHead, TableRow, TableCell, Paper, Avatar, Tooltip,
  TableBody, Accordion, AccordionDetails, AccordionSummary,
  Alert
} from '@mui/material';
import '../../styles/customStyle.css';
import { DialogWidget } from "../../Widget"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { customStyles } from '../../styles/tableStyle';




const Module = (props) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [children, setChildren] = useState([]);

  useEffect(() => {
    setSelectedItem(props.item)
    return () => console.log("Cleanup..");
  }, [props.item]);


  const handleModuleChange = (event, nodeId) => {
    // setRegister(nodeId)
    setChildren(nodeId.children)
  }

  return (
    <Box sx={{ border: '1px solid' }}>
      <Card elevation={3} variant="outlined" sx={{ height: '60vh', overflow: 'auto' }}>
        <CardHeader
          title={selectedItem ? selectedItem.label : ""}
          sx={{
            "& .MuiCardHeader-title": customStyles.title,
          }}
        >
        </CardHeader>
        <CardContent>
          <Typography variant="subtitle2" style={{ textAlign: 'left' }}>Instance :{selectedItem ? selectedItem.instanceName : ""}</Typography>
          <Typography variant="subtitle2" style={{ textAlign: 'left' }}>BaseAddress : {selectedItem ? selectedItem.baseAddress : ""}</Typography>

          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'left' }}>

            {selectedItem && selectedItem.children && selectedItem.children.map(item => {
              return (
                <Accordion sx={{m:1,p:1}}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon onClick={(e) => handleModuleChange(e, item)} />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography component="span">{item.label}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {item.children && item.children.length ? <TableContainer component={Paper}>
                      <Table sx={{}}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Bit-Pos</TableCell>
                            <TableCell>Desc</TableCell>
                            <TableCell>DefaultValue</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {item.children.map((row) => {
                            return (<TableRow key={row}>
                              <TableCell>{row.name}</TableCell>
                              <TableCell>{row.fieldType}</TableCell>
                              <TableCell>{row.bitPosition}</TableCell>
                              <TableCell>{row.desc}</TableCell>
                              <TableCell>{row.defaultValue}</TableCell>

                            </TableRow>)
                          })}
                        </TableBody>
                      </Table>

                    </TableContainer> : false}
                  </AccordionDetails>
                </Accordion>
              )
            })}
          </div>

        </CardContent>

      </Card>
    </Box >
  );
};

export default React.memo(Module);
